import React from 'react'
import {
  Col,
  Form,
  FormItemProps,
  Input,
  InputProps,
  Row,
  Typography,
} from 'antd'
import { useController, UseControllerProps } from 'react-hook-form'

type Props<T extends Record<string, any>> = {
  inputProps?: InputProps
  controller: UseControllerProps<T>
  errorCol?: 12 | 24
} & Omit<FormItemProps, 'children'>

function InputField<T extends Record<string, any>>(props: Props<T>) {
  const { inputProps, controller, errorCol = 24, label, ...rest } = props
  const { fieldState, field } = useController<T>(controller)
  const { error } = fieldState

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    inputProps?.onChange?.(e)
    field.onChange(e)
  }

  return (
    <Form.Item
      colon={false}
      label={label}
      labelAlign="left"
      labelCol={label ? { span: 24 } : undefined}
      wrapperCol={label ? { span: 24 } : undefined}
      validateStatus={error ? 'error' : ''}
      {...rest}
    >
      <Row gutter={4}>
        <Col span={errorCol}>
          <Row gutter={8}>
            <Col span={24}>
              <Input
                {...field}
                {...inputProps}
                style={{ width: '100%' }}
                onChange={onChange}
                className="aga-input"
                status={error ? 'error' : undefined}
              />
            </Col>
          </Row>
        </Col>
        {error && (
          <Col span={errorCol}>
            <Typography.Text
              className="ant-form-item-explain ant-form-item-explain-error"
              type="danger"
              ellipsis={{ tooltip: false }}
              style={{
                lineHeight: errorCol === 24 ? '20px' : '42px',
                overflow: 'visible',
                whiteSpace: 'break-spaces',
              }}
            >
              {error.message}
            </Typography.Text>
          </Col>
        )}
      </Row>
    </Form.Item>
  )
}

export default InputField
